import { Injectable } from '@angular/core';
import { OneSignal } from 'onesignal-ngx';
import { Globals } from '@smarttask-common/src/lib/services/globals';

@Injectable({ providedIn: 'root' })
export class OneSignalService {
    private initialized = false;

    constructor(private oneSignal: OneSignal, private globals: Globals) {}

    init = () => {
        if (this.initialized) return;
        this.initialized = true;

        this.oneSignal.init({
            appId: this.globals.one_signal_app_id,
            allowLocalhostAsSecureOrigin: true,
            serviceWorkerPath: 'assets/scripts/oneSignal/OneSignalSDKWorker.js',
            serviceWorkerParam: { scope: '/assets/scripts/oneSignal/' },
        }).then(() => {
            if (Notification.permission === 'granted') {
                this.loginAndTag();
            }
        });
    };

    // 'default' = never asked, 'granted' = allowed, 'denied' = blocked by user
    get permission(): NotificationPermission {
        return Notification.permission;
    }

    get isOptedIn(): boolean {
        return this.oneSignal.User?.PushSubscription?.optedIn ?? false;
    }

    private loginAndTag = () => {
        const { user_id, email } = this.globals.auth_data;
        this.oneSignal.login(user_id.toString());
        this.oneSignal.User.addTags({ user_id: user_id.toString(), email });
    };

    optIn = () => {
        if (Notification.permission === 'default') {
            this.oneSignal.Notifications.requestPermission().then((granted) => {
                if (granted) {
                    this.loginAndTag();
                }
            });
        } else if (Notification.permission === 'granted') {
            this.oneSignal.User.PushSubscription.optIn();
        }
    };

    optOut = () => {
        this.oneSignal.User.PushSubscription.optOut();
    };

    logout = () => {
        this.oneSignal.logout();
    };
}
